import { render, staticRenderFns } from "./integrallist.vue?vue&type=template&id=3f8f95b7&scoped=true&"
import script from "./integrallist.vue?vue&type=script&lang=js&"
export * from "./integrallist.vue?vue&type=script&lang=js&"
import style0 from "./integrallist.vue?vue&type=style&index=0&id=3f8f95b7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8f95b7",
  null
  
)

export default component.exports